__turbopack_context__.v({
  "card": "Features-module__jLYcwq__card",
  "cardImage": "Features-module__jLYcwq__cardImage",
  "cardImageWrapper": "Features-module__jLYcwq__cardImageWrapper",
  "cardSubtitle": "Features-module__jLYcwq__cardSubtitle",
  "cardTitle": "Features-module__jLYcwq__cardTitle",
  "cardVideo": "Features-module__jLYcwq__cardVideo",
  "cardsContainer": "Features-module__jLYcwq__cardsContainer",
  "section": "Features-module__jLYcwq__section",
  "textContainer": "Features-module__jLYcwq__textContainer",
});
